import { or, schemaMatches } from '@jsonforms/core';
const isDateDescription = (s) => s.description === 'org.joda.time.DateTime';
const isDate = schemaMatches(isDateDescription);
export const isOneOfDate = or(isDate, schemaMatches((schema) => schema.hasOwnProperty('oneOf') &&
    schema.oneOf.some((s) => s.description === 'org.joda.time.DateTime')));
